import {t} from './i18n.mjs';
// The live badge is a button; a small bubble below it explains live updates or the current interruption.
// Closes on a second click, Escape, or any press outside badge and bubble.
export const liveText = state => state === 'open' ? t('liveExplanation') : t('liveReconnecting');

export function livePopover(badge, bubble, doc = document) {
  let state = 'off';
  const isOpen = () => !bubble.hidden;
  const render = () => { bubble.querySelector('.popover-text').textContent = liveText(state); };
  // Point the arrow at the badge centre, measured relative to the bubble's left edge.
  function aim() {
    if (!badge.getBoundingClientRect || !bubble.getBoundingClientRect) return;
    const b = badge.getBoundingClientRect(), p = bubble.getBoundingClientRect();
    bubble.style?.setProperty('--arrow-x', Math.round(b.left + b.width / 2 - p.left) + 'px');
  }
  function open(show) {
    if (show) render();
    bubble.hidden = !show; badge.setAttribute('aria-expanded', String(show));
    if (show) aim();
  }
  badge.addEventListener('click', () => open(!isOpen()));
  doc.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !isOpen()) return;
    event.stopPropagation(); open(false); badge.focus();
  }, true);
  doc.addEventListener('pointerdown', event => {
    if (isOpen() && !badge.contains(event.target) && !bubble.contains(event.target)) open(false);
  }, true);
  return {
    setState(next) { state = next; if (isOpen()) render(); },
    open, get isOpen() { return isOpen(); },
  };
}
